export const API_URL = {
  mock: '',
  dev: 'https://free-advisory.apigw.qa.91jkys.com/api/',
  qa: 'https://free-advisory.apigw.qa.91jkys.com/api/',
  pre: 'https://apigw.pre.91jkys.com/api/',
  pro: 'https://apigw.91jkys.com/api/'
};

export const STATIC_URL = {
  mock: 'http://static.qa.91jkys.com/',
  dev: 'https://static.qa.91jkys.com/',
  qa: 'https://static.qa.91jkys.com/',
  pre: 'https://static.pre.91jkys.com/',
  pro: 'https://static.91jkys.com/'
};

export const CALL_IOS_APP_DEEPLINK = {
  mock: 'https://deeplink.91jkys.com/zyhealthtest',
  dev: 'https://deeplink.91jkys.com/zyhealthtest',
  qa: 'https://deeplink.91jkys.com/zyhealthtest',
  pre: 'https://deeplink.91jkys.com/zyhealthpre',
  pro: 'https://deeplink.91jkys.com/zyhealth'
};

export const ANDROID_URL_SCHEME = 'zyhealth://zyhealth.com';

// 埋点

export const TRACKIDS = {
  view: {
    '1': 'Kaer-view-moudle-doctor1*1',
    '2': 'Kaer-view-moudle-doctor-1*2',
    '3': 'Kaer-view-moudle-doctor-1*3',
    '9999':'Kaer-view-moudle-doctor-1*n'
  },
  event: {
    '1': 'Kaer-click-moudle-doctor-1*1',
    '2': 'Kaer-click-moudle-doctor-1*2',
    '3':'Kaer-click-moudle-doctor-1*3',
    '9999':'Kaer-click-moudle-doctor-1*n',
  }
}